import { environment } from 'environments/environment';

/**
 * 控管單一瀏覽器中，只有一個使用者登入使用
 */
export class SingleBrowserUtils {

    canCheck: boolean;
    enable: boolean;

    constructor(
        private debug: boolean, private kxy: string, private interval: number, private errFunc: Function
    ) {
        if (environment.isDemo) {
            return;
        }
        this.canCheck = true;
        this.enable = false;
        if (typeof (sessionStorage) !== 'undefined' || typeof (localStorage) !== 'undefined') {
            // console.log('sessionStorage=' + sessionStorage + ',' + localStorage);
            if (sessionStorage != null && localStorage != null) {
                this.log('enable lock');
                this.enable = true;
            }
        }


    }

    /** 持續確認. */
    repeatCheck(): void {
        if (environment.isDemo) {
            return;
        }
        if (this.enable) {
            this.log('do lockable check');
            if (this.lockable()) {
                this.lock();
                this.log('can lock ' + this.canCheck);
                if (this.canCheck) {
                    setTimeout(() => {
                        this.repeatCheck();
                    }, this.interval * 1000 / 2.2);

                }
            } else {
                this.log('lock failed');
                if (typeof (this.errFunc) !== 'undefined') {
                    this.errFunc();
                }
            }
        }
    }

    /** 鎖定. */
    lock(): void {
        if (environment.isDemo) {
            return;
        }
        this.log('lock ' + new Date().getTime());

        let timelong = '' + new Date().getTime();
        sessionStorage.setItem(this.kxy, timelong);
        localStorage.setItem(this.kxy, timelong);
    };

    /** 是否可以鎖定. */
    lockable(): boolean {
        if (environment.isDemo) {
            return true;
        }
        let now: Date = new Date();
        let lockTimeStr = localStorage.getItem(this.kxy);
        this.log('lockable lockTimeStr:' + lockTimeStr);
        if (lockTimeStr !== null) {
            if (sessionStorage.getItem(this.kxy) === lockTimeStr) {
                return true;
            } else {
                let lockTime: Date = new Date(parseInt(lockTimeStr, 0));
                let diff = (now.getTime() - lockTime.getTime()) / 1000;	// time diff in second.
                this.log('S:' + sessionStorage.getItem(this.kxy) + ', L:' + lockTime.getTime() + ', D:' + diff + ', I:' + this.interval);

                if (diff < this.interval) {
                    return false;
                }
            }
        }
        return true;
    };

    /** 停止確認. */
    stopCheck(): void {
        this.canCheck = false;
    }

    /** log訊息 */
    log(msg: string) {
        try {
            if (this.debug) {
                if (window.console) {
                    console.log(msg);
                }
            }
        } catch (e) { }
    }
}



